export const getNewbuildingSubdomain = (hostname: string, geoSubdomain: string): string | null => {
  const subdomain = (hostname && hostname.split('.')[0]) || '';

  if (!subdomain.startsWith('zhk-')) {
    return null;
  }

  const subdomainParts = subdomain.split('-');

  return subdomainParts.length === 2 || subdomainParts.pop() === geoSubdomain ? subdomain : null;
};
